// Core packages
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';

// Third party packages
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

// Custom packages
import { ConfigService } from 'src/app/shared/services/config.service';

@Component({
  selector: 'app-choose-role-dialog',
  templateUrl: './choose-role-dialog.component.html',
  styleUrls: ['./choose-role-dialog.component.scss']
})
export class ChooseRoleDialogComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  userRoles: any[];
  chosenRole: string;
  displayedRoles = [];

  /**
   * Class constructor
   */
  constructor(
    public configService: ConfigService,
    public dialogRef: MatDialogRef<ChooseRoleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    dialogRef.disableClose = true; // Disable close by clicking outside of the dialog
  }

  /**
   * Init component
   */
  ngOnInit(): void {
    this.userRoles = this.data.user.userRoles;
    this.chosenRole = this.userRoles[0]._id;
    this.userRoles.sort((a: any, b: any) => {
      const nameA = a.role.name.toUpperCase(); // ignora maiuscole e minuscole
      const nameB = b.role.name.toUpperCase(); // ignora maiuscole e minuscole
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
    
      return 0;
    });
  }

  /**
   * Handle component destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Handle dialog closing
   *
   * @since 1.0.0
   *
   * @param [roleId] optional data passed to the caller component
   */
  onClose(roleId?: string): void {
    const chosenRole = this.userRoles.filter((el: any) => { return el._id === roleId })[0];
    this.dialogRef.close(chosenRole);
  }
}
